import {CBTextBox} from "../../../components/common/ContentBox";
import {activateTotp, enrollCall} from "../../../services/api/factorApi";
import {runApi} from "../../../services/api/ApiContext";
import {useState} from "react";
import {toast} from "react-toastify";
import IconCall from "../../../../images/icon_call.png";
import IconUser from "../../../../images/icon_user.png"
import {
    AuthBox,
    AuthContent,
    AuthIcon,
    AuthButton,
    AuthBack,
    AuthIntro,
    AuthReButton
} from "../../common/AuthBox";
import {useHistory} from "react-router-dom";
import {useFactors} from "../../../contexts/FactorsContext";
import {countriesList, numberList} from "./config";
import IconError from "../../../../images/error.png";

const OktaEnrollOktaCall = () => {

    const [enrollStep, setEnrollStep] = useState(1);
    const [passCode, setPassCode] = useState("");
    const [factorId, setFactorId] = useState(null);
    const [selectedConCode, setSelectedConCode] = useState(1);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [extension, setExtension] = useState("");
    const [error, setError] = useState(null);
    const [sentCode, setSentCode] = useState(null);
    const [reSendCode, setReSendCode] = useState(null);
    const [blankToken, setBlankToken] = useState(null);
    const [blankPhone, setBlankPhone] = useState(null);
    const [lastPhoneNumber, setLastPhoneNumber] = useState(null);
    const [lastConCode, setLastConCode] = useState(null);
    const [lastExten, setLastExten] = useState(null);
    const history = useHistory();
    const {refresh} = useFactors();
    const enroll = async () => {
        if (!phoneNumber) {
            setBlankPhone(true);
            return;
        }
        setReSendCode(false);
        setError(false);
        setLastPhoneNumber(phoneNumber);
        setLastConCode(selectedConCode);
        setLastExten(extension);
        const enrollOktaCallResponse = await runApi(
            'enrollCall',
            () => enrollCall("+" + selectedConCode + phoneNumber, extension)
        );

        if (!enrollOktaCallResponse?.data?.status) {
            setError(true);
            setLastPhoneNumber(null);
            setLastConCode(null);
            setLastExten(null);
            return;
        }
        // console.log(enrollOktaCallResponse);
        setEnrollStep(3);
        setSentCode(true);
        startResendCount();
        setFactorId(enrollOktaCallResponse?.data?.data?.id);
    }

    const startResendCount = () => {
        setTimeout(
            function () {
                setReSendCode(true);
                setSentCode(false)
            },
            30000
        );
    }

    const toStep2 = () => {
        setEnrollStep(2);
    }

    const activate = async () => {
        if (!passCode) {
            setBlankToken(true);
            return;
        }

        const activateCallAuthResponse = await runApi(
            'enrollCallAuth',
            () => activateTotp(factorId, passCode)
        );

        if (!activateCallAuthResponse?.data?.status) {
            setError(true);
            return;
        }

        toast.success("Activate voice call successfully.")
        finishActivate();
    }

    const finishActivate = () => {
        refresh();
        history.push('/profile/mfa');
    }

    const getCountriesByCode = (code) => {
        const countryNumber = numberList[code];
        setSelectedConCode(countryNumber);
    }

    const handlePassCodeChange = (event) => {
        setPassCode(event.target.value);
        setBlankToken(false);
        setError(false);
    }

    const handlePhoneNumberChange = (event) => {
        setPhoneNumber(event.target.value);
        setBlankPhone(false);
    }

    const resend = () => {
        enroll();
    }

    return (
        <AuthBox>
            <AuthIcon src={enrollStep === 1 ? IconUser : IconCall}/>
            {enrollStep === 1 &&
            <AuthIntro Title={"Voice Call Authentication"}
                       Description={"Use a phone to authenticate by following voice instructions."}
                       Icon={IconCall} nextEvent={() => toStep2()}/>}
            {(enrollStep === 2 || enrollStep === 3) &&
            <AuthContent>
                <p><strong>Follow phone call instructions to authenticate</strong></p>
                {error &&
                <div className="infobox-error clearfix">
                    <span className="error-icon"><img src={IconError} alt="error" width="16"/></span>
                    <p>We found some errors. Please review the form and make corrections.</p>
                </div>
                }
                {reSendCode && <div className="infobox-warning clearfix">
                    <span className="error-icon"><img src={IconError} alt="error" width="16"/></span>
                    <p>Haven't received a voice call? To try again, click Redial.</p>
                </div>}
                <form className="code-via-sms">
                    {<select className="select-city"
                             onChange={(event) => getCountriesByCode(event.target.value)}> {countriesList ? countriesList.map(function (val, idx) {
                        return <option value={val.code} selected={val.code === "US"}>{val.name}</option>;
                    }) : []}
                    </select>}
                    <div className="clearfix">
                        <div className="call-phone-num">
                            <label>Phone number</label>
                            <div className="phone-num clearfix">
                                <span className="city-num">+{selectedConCode}</span>
                                <input type="text" name="phone" value={phoneNumber}
                                       onChange={e => handlePhoneNumberChange(e)}/>
                            </div>
                            {blankPhone && <span className="form-input-error">This field cannot be left blank</span>}

                        </div>
                        <div className="call-extension">
                            <label>Extension</label>
                            <input type="text" name="phone" value={extension}
                                   onChange={e => setExtension(e.target.value)}/>
                        </div>
                    </div>
                    {reSendCode && lastPhoneNumber === phoneNumber && lastConCode === selectedConCode && lastExten === extension &&
                    <AuthReButton buttonEvent={() => resend()} buttonText={"Redial"}/>}
                </form>
                {((!sentCode && !reSendCode)  || (reSendCode && !(lastPhoneNumber === phoneNumber && lastConCode === selectedConCode && lastExten === extension))) &&
                <AuthButton buttonEvent={() => enroll()} buttonText={"Call"}/>}
                {sentCode && <AuthReButton buttonText={"Calling"}/>}
                {enrollStep === 3 && <div>
                    <form className="enter-code">
                        <label>Enter Code</label>
                        <CBTextBox disabled={false} value={passCode}
                                   onChange={e => handlePassCodeChange(e)}></CBTextBox>
                        {blankToken && <span className="form-input-error">This field cannot be left blank</span>}

                    </form>

                    <AuthButton buttonEvent={() => activate()} buttonText={"Verify"}/>
                </div>}
                <AuthBack src="/profile/mfa/enroll/OKTA/call"/>

            </AuthContent>}
        </AuthBox>
    );
};

export default OktaEnrollOktaCall;
